var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-REGULAR" }, [
    _c(
      "div",
      { staticClass: "SELECTIONS-RR" },
      _vm._l(_vm.betslipSelectionIds, function(id, index) {
        return _c("selection-rr", {
          key: id,
          class: [
            _vm.tab,
            {
              first: index == 0,
              last: index + 1 == _vm.allowedBetTypesRR.length
            }
          ],
          attrs: {
            id: id,
            currentBetSlipState: _vm.currentBetSlipState,
            tab: _vm.tab,
            allowedBetTypesAndReturns: {}
          }
        })
      }),
      1
    ),
    _vm._v(" "),
    !_vm.gettingABTnR &&
    _vm.currentBetSlipState <= 1 &&
    _vm.activeSelectionsNo >= 3 &&
    !_vm.allowedBetTypesRR.length
      ? _c(
          "div",
          {
            staticClass: "msg info noRRAvailable",
            class: {
              interRelated: _vm.hasActiveInteRelated,
              hasNonCombinableSelection: _vm.hasNonCombinableSelection
            }
          },
          [
            _c("v-icon", [_vm._v("info_outline")]),
            _vm._v(" "),
            _vm.hasActiveInteRelated && !_vm.hasNonCombinableSelection
              ? _c("span", [
                  _vm._v(_vm._s(_vm.$t("BetSlip.tab.RR.info.interRelated")))
                ])
              : _c("span", [
                  _vm._v(_vm._s(_vm.$t("BetSlip.tab.RR.info.noRRAvailable")))
                ])
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.gettingABTnR &&
    _vm.currentBetSlipState <= 1 &&
    _vm.activeSelectionsNo < 3 &&
    !_vm.allowedBetTypesRR.length
      ? _c(
          "div",
          { staticClass: "empty-betslip msg info" },
          [
            _c("v-icon", [_vm._v("info_outline")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("BetSlip.tab.RR.emptyInfoMsg")))])
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.betsNo > 1
      ? _c(
          "div",
          { staticClass: "RRs" },
          _vm._l(_vm.allowedBetTypesRR, function(bT, index) {
            return _c("bet-type-rr", {
              key: bT.IDFOBetType,
              class: {
                first: index == 0,
                last: index + 1 == _vm.allowedBetTypesRR.length
              },
              attrs: {
                id: bT.IDFOBetType,
                currentBetSlipState: _vm.currentBetSlipState,
                tab: _vm.tab,
                allowedBetTypesAndReturns: bT
              }
            })
          }),
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.betsNo > 1 &&
    _vm.allowedBetTypesAndReturns &&
    _vm.allowedBetTypesAndReturns.PerBetType &&
    _vm.allowedBetTypesAndReturns.PerBetType.A
      ? _c(
          "div",
          { staticClass: "PARLAY" },
          [
            _c("bet-type-parlay", {
              key: "A",
              attrs: {
                id: "A",
                currentBetSlipState: _vm.currentBetSlipState,
                tab: _vm.tab,
                allowedBetTypesAndReturns:
                  _vm.allowedBetTypesAndReturns.PerBetType.A
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b470c54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b470c54","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/rootElements/tabs/tabRoundRobin.vue
// module id = null
// module chunks = 